module.exports = __webpack_public_path__ + "img/ui.9e29322c.svg";